/**
 *
 * AdminSkudDxGridContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { requestAction } from 'domain/typeConstants/action';
import * as actionCreators from './actions';

class AdminSkudDxGridContainer extends React.PureComponent {

  handleRowDoubleClick = (record) => this.props.executeEditAction(record.id);

  handleActionExecuting = (actionName, ids) => {
    switch (actionName) {
      case requestAction.ADD:
        this.props.executeAddAction();
        break;

      case requestAction.EDIT:
        this.props.executeEditAction(ids[0]);
        break;

      case requestAction.COPY:
        this.props.executeCopyAction(ids[0]);
        break;

      case requestAction.ACCEPT:
        this.props.executeAcceptAction(ids);
        break;

      case requestAction.REJECT:
        this.props.executeRejectAction(ids);
        break;

      default:
        throw new Error('Executed a unknown action.');
    }
  };

  render() {
    const { component, viewName } = this.props;

    return React.cloneElement(component, {
      viewName,
      onActionExecuting: this.handleActionExecuting,
      onRowDoubleClick: this.handleRowDoubleClick,
    });
  }
}

AdminSkudDxGridContainer.propTypes = {
  component: PropTypes.node.isRequired,
  viewName: PropTypes.string.isRequired,
  executeAddAction: PropTypes.func.isRequired,
  executeEditAction: PropTypes.func.isRequired,
  executeCopyAction: PropTypes.func.isRequired,
  executeAcceptAction: PropTypes.func.isRequired,
  executeRejectAction: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(null, mapDispatchToProps)(AdminSkudDxGridContainer);
